import { swaggerSplitApi as api } from "../swaggerApi"
import { AuthSocialArgs, AuthSocialResponse, OAuth2LoginArgs } from "./types";
import { setUserCredentials } from "../appTokensStore";
import { hide } from "@pages/signIn/SignInSlice";

const authApi = api.injectEndpoints({
  overrideExisting: true,
  endpoints: build => ({
    googleLogin: build.mutation<AuthSocialResponse, AuthSocialArgs>({
      query: (arg:AuthSocialArgs)=> ({
        url: `/api/v1/auth/login/google/code`,
        method: "POST",
        body: arg,
      }),
      onQueryStarted: async (_, {dispatch, queryFulfilled}) => {
        const {data} = await queryFulfilled
        dispatch(
          setUserCredentials({
            applicationToken: data.access_token,
            refreshToken: data.refresh_token,
            userId: data.user_id,
          }),
        )
        dispatch(hide())
      }
    }),
    oauth2Login: build.mutation<AuthSocialResponse, OAuth2LoginArgs>({
      query: (arg: OAuth2LoginArgs) => ({
        url: `/api/v1/auth/login/oauth2`,
        method: "POST",
        body: arg,
      }),
      onQueryStarted: async (_, {dispatch, queryFulfilled}) => {
        const {data} = await queryFulfilled
        dispatch(
          setUserCredentials({
            applicationToken: data.access_token,
            refreshToken: data.refresh_token,
            userId: data.user_id,
          }),
        )
        dispatch(hide())
      }
    })
  })
})

export const {useGoogleLoginMutation, useOauth2LoginMutation} = authApi